<div class="centermodal__top">
  <p class="centermodal__title">{{ 'documents.fillFieldsForm.title' | translate }}</p>
  <p class="centermodal__description">{{ 'documents.fillFieldsForm.description' | translate }}</p>
</div>

@if (fieldsToFill && fieldsForm) {
  <form [formGroup]="fieldsForm" novalidate (change)="presentResult()" (input)="presentResult()">
    <div class="centermodal__form" formGroupName="filledFields">
      @for (field of fieldsToFill; track $index) {
        <!-- Para quando os campos de marcação forem liberados -->

        <!-- <div *ngIf="field.type == 'checkboxField'">
          <input
            type="checkbox"
            autocomplete="none"
            [required]="field.required"
            #nameInput
            [formControlName]="formatFieldName(field.name)"
            (change)="logResult()"
          
          />
          <span>{{ field.name }}</span>
        </div> -->

        <label class="field__holder" [appFormControlWrap]="fieldsForm.get('filledFields.' + field.name)">
          @if ([DynamicDocumentFieldsTypes.shortTextField, DynamicDocumentFieldsTypes.numberField].includes(field.type)) {
            <input
              [type]="field.type == DynamicDocumentFieldsTypes.numberField ? 'number' : 'text'"
              class="field"
              autocomplete="none"
              [required]="field.required"
              [formControlName]="field.name"
              [appMatchRegex]="field.regex"
              (focus)="focusedField = field.name"
              (blur)="focusedField = null"
              maxlength="255"
            />
          } @else if (field.type == DynamicDocumentFieldsTypes.cpfField) {
            <input
              type="tel"
              class="field"
              [formControlName]="field.name"
              [class.has-error]="validationErrors?.configs?.cpf"
              [appValidCpf]="!validationErrors?.configs?.cpf"
              mask="000.000.000-00"
              [dropSpecialCharacters]="false"
              [specialCharacters]="['.', '-']"
              [required]="field.required"
              [appMatchRegex]="field.regex"
              (focus)="focusedField = field.name"
              (blur)="focusedField = null"
            />
          } @else if (field.type == DynamicDocumentFieldsTypes.cnpjField) {
            <input
              type="tel"
              class="field"
              [formControlName]="field.name"
              [class.has-error]="validationErrors?.configs?.cnpj"
              [appValidCnpj]="!validationErrors?.configs?.cnpj"
              mask="00.000.000/0000-00"
              [dropSpecialCharacters]="false"
              [specialCharacters]="['.', '/', '-']"
              [required]="field.required"
              [appMatchRegex]="field.regex"
              (focus)="focusedField = field.name"
              (blur)="focusedField = null"
            />
          } @else if (field.type == DynamicDocumentFieldsTypes.cepField) {
            <input
              type="tel"
              class="field"
              [formControlName]="field.name"
              mask="00000-000"
              [dropSpecialCharacters]="false"
              [specialCharacters]="['-']"
              [required]="field.required"
              [appMatchRegex]="field.regex"
              (focus)="focusedField = field.name"
              (blur)="focusedField = null"
            />
          } @else if (field.type == DynamicDocumentFieldsTypes.dateField) {
            <input
              type="tel"
              class="field"
              [formControlName]="field.name"
              mask="00/00/0000"
              [dropSpecialCharacters]="false"
              [specialCharacters]="['/']"
              [required]="field.required"
              [appValidDate]="dateFormat"
              [appMatchRegex]="field.regex"
              (focus)="focusedField = field.name"
              (blur)="focusedField = null"
            />
          } @else if (field.type == DynamicDocumentFieldsTypes.longTextField) {
            <textarea
              class="field"
              autocomplete="none"
              [required]="field.required"
              [formControlName]="field.name"
              [appMatchRegex]="field.regex"
              (focus)="focusedField = field.name"
              maxlength="255"
            ></textarea>
          } @else if (field.type == DynamicDocumentFieldsTypes.phoneField) {
            <app-phone-number
              inputClass="field"
              [formControlName]="field.name"
              name="phone"
              autocomplete="tel-national"
              appValidPhone
              [required]="field.required"
              [appMatchRegex]="field.regex"
              (focus)="focusedField = field.name"
              (blur)="focusedField = null"
            ></app-phone-number>
          }

          <span class="field__placeholder">{{ field.name + (field.required ? ' *' : '') }}</span>
          @if (field.help_text && focusedField === field.name && !(fieldsForm.get('filledFields.' + field.name).invalid && fieldsForm.get('filledFields.' + field.name).touched)) {
            <p class="centermodal__description field__description">{{ field.help_text }}</p>
          }
        </label>
      }
    </div>

    <button type="submit" class="btn-L btn-filled d-flex ml-auto" [disabled]="fieldsForm.invalid || disabled" (click)="submitFilledFields()">
      {{
        currentSigner?.action
          ? ('signature.signAction.' + ((currentSigner && currentSigner?.action && currentSigner?.action.name) || 'SIGN' | lowercase) | translate)
          : ('signature.signAction.fill' | translate)
      }}
    </button>
  </form>
}
@if (!isRendered) {
  <div class="form__container">
    <div class="rendering rendering__form-field"></div>
    <div class="rendering rendering__form-field"></div>
    <div class="rendering rendering__form-field"></div>
    <div class="rendering rendering__form-field"></div>
  </div>
}
